import axios from 'axios'

export async function getIntegrationsAndApiData() {
    const { data } = await axios.get(
        `${process.env.API_URL}/billing/integrations-and-api-data`
    )
    return data
}
